import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

@Injectable({
    providedIn: 'root'
})
export class VisitorPathologyService extends ApiService {
    getByVisitors(data: any) {
        return super.post('/visitors-pathology/visitors', data);
    }

    create(data: any) {
        return super.post('/visitors-pathology/create', data);
    }

    update(data: any) {
        return super.put('/visitors-pathology/update', data);
    }

    delete(id: number) {
        return super.delete('/visitors-pathology/' + id);
    }
}
